// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2xpRe","rootSuccess":"CompleteLink_rootSuccess__1jsyK","rootFailure":"CompleteLink_rootFailure__FGwlX","isDisabled":"CompleteLink_isDisabled__28VWX"};